var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6903_128830)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.027 50.7677C43.1999 54.9614 36.8964 57.5 30 57.5C14.8122 57.5 2.5 45.1878 2.5 30C2.5 22.8594 5.22149 16.3545 9.68381 11.4659L48.027 50.7677ZM49.8384 49.0444L11.4511 9.69735C16.3414 5.227 22.8522 2.5 30 2.5C45.1878 2.5 57.5 14.8122 57.5 30C57.5 37.3919 54.5835 44.1027 49.8384 49.0444ZM60 30C60 46.5685 46.5685 60 30 60C13.4314 60 0 46.5685 0 30C0 13.4314 13.4314 0 30 0C46.5685 0 60 13.4314 60 30Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6903_128830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotUse);
export default __webpack_public_path__ + "static/media/icon-not-use.f2b924f980adbfc4e25db9f3b7d1a1ec.svg";
export { ForwardRef as ReactComponent };